import {Component, Injector, OnInit} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {NgIf} from "@angular/common";
import {RouteUtil} from "../../../util/route.util";
import {BaseComponent} from "../../base.component";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    MatIconModule,
    NgIf,
    RouterLink
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent extends BaseComponent implements OnInit {
  fullImage?: any;

  constructor(injector: Injector) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  showFullImage(imageUrl: string, event: Event) {
    event.preventDefault();
    this.fullImage = imageUrl;
  }

  openBazarLink() {
    window.open('https://cafebazaar.ir/app/com.aminsft.baazar2', '_blank');
  }

  openGooglePlayLink() {
    window.open('https://cafebazaar.ir/app/com.aminsft.baazar2', '_blank');
  }

  openMayketLink() {
    window.open('https://myket.ir/app/com.baazarplus.app', '_blank');
  }

  openAparatLink() {
    window.open('https://www.aparat.com/baazar97', '_blank');
  }

  openBaleLink() {
    window.open('https://ble.ir/baazargold', '_blank');
  }

  openTelegramLink() {
    window.open('https://t.me/baazar_tala', '_blank');
  }

  openInstagramLink() {
    window.open('https://www.instagram.com/baazarofficial/', '_blank');
  }

  onRolesClicked() {
    this.router.navigate([RouteUtil.ROLES]).then(() => {
      const outletContainer = document.getElementById('outlet-container');
      if (outletContainer) {
        outletContainer.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    });
  }

}
